import { Step } from 'react-joyride';

export const UppercaseTutorialSteps: Step[] = [
  {
    target: '#shift-key-left',
    content: '',
    placement: 'top',
    disableBeacon: true,
    data: {
      contents: [
        {
          tutorialTxt: <><ruby>大文字<rt>おおもじ</rt></ruby>を<ruby>打<rt>う</rt></ruby>つ<ruby>時<rt>とき</rt></ruby>は</>,
          style: 'tooltipText1',
        },
        {
          tutorialTxt: <>シフトキーを<ruby>押<rt>お</rt></ruby>したまま</>,
          style: 'tooltipText2',
        },
        {
          tutorialTxt: <><ruby>大文字<rt>おおもじ</rt></ruby>にしたいキーを<ruby>打<rt>う</rt></ruby>とう！</>,
          style: 'tooltipText3',
        },
      ],
      buttonLabel: 'つぎへ',
      displayWord: 'A',
    },
  },
  {
    target: '#shift-key-right',
    content: '',
    placement: 'top',
    disableBeacon: true,
    data: {
      contents: [
        {
          tutorialTxt: <><ruby>シフトキーは<rt>　</rt></ruby></>,
          style: 'tooltipText1',
        },
        {
          tutorialTxt: <><ruby>左右<rt>さゆう</rt></ruby>どちらを<ruby>使<rt>つか</rt></ruby>っても<ruby>大丈夫<rt>だいじょうぶ</rt></ruby>だよ！</>,
          style: 'tooltipText2',
        },
      ],
      buttonLabel: 'わかった',
      displayWord: 'A',
    },
  },
];